import { liveChatService } from '@gig/magic-messaging';
import {
    config,
    zendeskChat,
    liveChat,
    maxContact,
    salesforceMessaging,
    intercom,
} from '../services';

export const openProperLiveChat = () => {
    if (config.zendesk?.sdkUrl) {
        zendeskChat.startingZendesk();
    } else if (config.LC?.sdkUrl) {
        liveChat.maximizeChat();
    } else if (config.maxContact?.sdkUrl) {
        maxContact?.loadMaxContact();
    } else if (config.salesforceMessaging?.sdkUrl) {
        salesforceMessaging?.loadEmbeddedMessaging();
    } else if (config.intercom?.appId) {
        intercom?.open();
    } else {
        liveChatService.openLiveAgent();
    }
};
